import { dynamicCustomEventTracking } from '../../../../../../lib/gtm';

export default function FailureStepViewModel() {
  const handleScheduleAppointment = () => {
    dynamicCustomEventTracking.send({ dynamicEventName: 'renovacao_pedido_agendar_consulta_mc' });
  };

  return { handleScheduleAppointment };
}
